export const dashboardService = {
  apiDashboardData(urldata = mixins.params()) {
    return this.request(this.api().getDashboard)
      .urltransform(urldata)
      .exec()
      .log()
      .get();
  },
};

export default dashboardService;